import React from 'react';

export class Constants{

	static postingFormName = "Posting-Form";
	
	//RJM 10/15/2020: Corresponds to multiple models
	// 1) Models\Vehicles\Vechicle.cs > Vehicle
	// TODO: Add vehicle attribute items
	static defaultVehicleInputData = 
		{
			"VIN" : "",
			"Make" : "",
			"Model" : "",
			"Year" : new Date().getFullYear(),
			"serialNumber" : "",
			"VehicleType" : "",
			"userFreeTextedVehicleType" : "",
			"VINDecodedVehicleType" : "",
			"vehicleCondition" : "",
			"memberNumber" : "",
			"lotNumber" : "",
			"attributeEditId" : "",
			"vehicleEditId" : "",
        };
   
	// RJM 10/14/2020: Models\Vehicles\VehiclePosting.cs > pickupLocationType
	// Usage: {Object.keys(Constants.locationType).map(key => 
	// <option value={key}>{Constants.locationType[key]}</option>
	// )}
	static locationType = {
		"0" : "Home or apartment",
		"1" : "Auction",
		"2" : "Company Site",
		"3" : "Auto Dealership",
		"4" : "Sea Port",
		"5" : "Airport Terminal",
		"7" : "Other"
	};

	// RJM 10/14/2020: Models\Vehicles\VehiclePosting.cs > pickupLocationType
	// Usage: {Object.keys(Constants.ContainerTerminal).map(key => 
	// <option value={key}>{Constants.ContainerTerminal[key]}</option>
	// )}
	static ContainerTerminal = {
		"value" : "6",
		"name" : "Container Terminal"
	}
	// RJM 11/19/2020: used to help lift state from origin and destination details cards to create posting.
	// Controllers\CreatePostingController.cs > freightPostingInputModel
	static defaultDeliveryAddressData = {
		"freightPostingInputModel.deliveryAddress" : "",
		"freightPostingInputModel.deliveryCity" : "",
		"freightPostingInputModel.deliveryState" : "Alabama",
		"freightPostingInputModel.deliveryCountry" : "United States",
		"freightPostingInputModel.deliveryPostalcode" : "",
	}
	static defaultLoadingAddressData = {
		"freightPostingInputModel.loadingAddress" : "",
		"freightPostingInputModel.loadingCity" : "",
		"freightPostingInputModel.loadingState" : "Alabama",
		"freightPostingInputModel.loadingCountry" : "United States",
		"freightPostingInputModel.loadingPostalcode" : "",
	}

	// RJM 10/29/2020: Models\Freight\Vehicles\VehiclePosting.cs > vehicleMoveCondition
	static vehicleMoveCondition = {
		"Running" : {
			"value" : "0",
			"displayValue" : "Running"
		},
		"ForkliftNeeded" : {
			"value" : "1",
			"displayValue" : "Forklift needed"
		},
		"NonRunning" : {
			"value" : "2",
			"displayValue" : "Non-running"
		},
	}
	// RJM 10/15/2020: Models\Vehicles\Vechicle.cs > VehicleType
	// Usage: {Object.keys(Constants.VehicleType).map(key => 
	// <option value={key}>{Constants.VehicleType[key]}</option>
	// )}
	static VehicleType = {
		"0" : "Car",
        "1" : "SUV",
        "2" : "Pickup truck",
		"3" : "Semi truck",
        "4" :"Motorcycle",
        "5" : "ATV",
        "6" : "Van",
        "7" : "Boat",
        "8" : "Heavy equipment",
        "9" : "RV",
        "10" : "Travel trailer",
        "11" : "Other"
	}
	
	// RJM 10/14/2020: Controllers\CreatePosting.cs > freightType
	static freightType = {
		"vehicle" : "vehicle",
		"container" : "container"
    };
	
	// RJM 12/23/2020: Models\Preferences\OrderIDPref.cs > orderIDType
	static orderIDType = {
		"Number" : "Number",
		"Alphabetical" : "Alphabetical",
		"Freeform" : "Freeform"
	};

    // RJM 10/28/2020: Models\Freight\Container\Container.cs > ContainerSize 
    static ContainerSize = {
        "TwentyFoot" : {
            "value" : "TwentyFoot",
            "displayValue" : "20 ft"
        },
        "FortyFoot" : {
            "value" : "FortyFoot",
            "displayValue" : "40 ft"
        },
    };
     
    static defaultContainerInputData = 
        {
            "size" : Constants.ContainerSize.TwentyFoot.value,
            "bookingNumber" : "",
			//"containerNumber" : ""
			"containerEditId" : "",
		};
	
	// RJM 11/19/2020: Used by PricingTable.js, mirrors values in Models\RoutePricing.cs > RoutePricing.cs
	static defaultRoutePricingData = 
	{
		"loadingAddress" : "",
		"deliveryAddress": "",
		"pricePaid" : "",
		"cargoDescription" : "",
		"pricingType" : ""
	}
	// RJM 10/15/2020: appConstants.cs > maxNumVehiclesPerPosting
	static maxNumVehiclesPerPosting = 14;

	static maximumContainersPerPosting = (size) => {
		if(size == Constants.ContainerSize.TwentyFoot.value){
			return 2;
		}else if(size == Constants.ContainerSize.FortyFoot.value){
			return 1;
		}else{
			throw "Invalid container size provided when trying to get the maximum number of containers";
		}
	}

	static vehicleMakeList = (id) => {
        return(
            <datalist id={id}>
                <option>ACME</option>
                <option>Acura</option>
                <option>Aston Martin</option>                
                <option>Audi</option>
                <option>Bentley</option>
                <option>BMW</option>
                <option>Bugatti</option>
                <option>Buick</option>
                <option>Cadillac</option>
                <option>Chevrolet</option>
                <option>Chrysler</option>
                <option>Dodge</option>
                <option>Ford</option>
                <option>Ferrari</option>
                <option>GMC</option>
                <option>Honda</option>
                <option>Hyundai</option>
                <option>Saab</option>
                <option>Jaguar</option>
                <option>Kia</option>
                <option>Lamborghini</option>
                <option>Land Rover</option>
                <option>Lexus</option>
                <option>Lincoln</option>
                <option>Mack</option>
                <option>Maserati</option>
                <option>Mazda</option>
                <option>Mercedes-Benz</option>
                <option>Mitsubishi</option>
                <option>Nissan</option>
                <option>Optima</option>
                <option>Porsche</option>
                <option>Pontiac</option>
                <option>Ram</option>
                <option>Rolls Royce</option>
                <option>Toyota</option>
                <option>Subaru</option>
                <option>Volkswagen</option>
                <option>Volvo</option>
            </datalist>
        )
    }

    getNotificationsFromUrlVars = () => {
        var messages = [];
        var types = [];
        var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            if(key === "message"){
                messages.push(value);
            }
            if(key === "type"){
                types.push(value);
            }
        });
        return {messages,types};
	}
	
	// RJM 10/21/2020: appConstants.cs > StatesList
	static StatesList = ["Alabama","Alaska","Arizona","Arkansas","California","Colorado","Connecticut","Delaware","District of Columbia","Florida","Georgia","Hawaii","Idaho","Illinois","Indiana","Iowa","Kansas","Kentucky","Louisiana","Maine","Maryland","Massachusetts","Michigan","Minnesota","Mississippi","Missouri","Montana","Nebraska","Nevada","New Hampshire","New Jersey","New Mexico","New York","North Carolina","North Dakota","Ohio","Oklahoma","Oregon","Pennsylvania","Rhode Island","South Carolina","South Dakota","Tennessee","Texas","Utah","Vermont","Virginia","Washington","West Virginia","Wisconsin","Wyoming"];

	// RJM 12/31/2020: Controllers\CreatePostingController.cs > Post() > returnPageName
	static pageNameToUrlMap = {
		"MyVehicles" : "/VehiclePosting/MyVehicles/",
		"MyContainers" : "/ContainerPosting/MyContainers/"
	}
	static messageIDToMessageMap = {
		"PostingSubmitSuccess" : "Your posting has been successfully submitted"
	}

	static postingType = {
		"normal" : { 
			"value" : "normal",
			"displayValue" : "Regular",
			"description" : "Creating a posting with all information needed to assign to a carrier"
		},
		"quickPosting" : {
			"value" : "quickPosting",
			"displayValue" : "Quick Posting",
			"description" : "Creating a posting with only essential information. Appears to truckers, but must be completed before assignment"
		},
		"postAndDispatch" : {
			"value" : "postAndDispatch",
			"displayValue" : "Post And Dispatch",
			"description" : "Creating a posting and assign a carrier to it right away"
		}
	}
}